import React from "react"
import { OrderDetails } from "../../../features/gardners"

import AuthGuard from "../../../features/ui/containers/AuthGuard"
import PageLayout from "../../../layouts/PageLayout"

const Selected = () => (
  <AuthGuard>
    <PageLayout
      flexDirection="column"
      width={1 / 1}
      px={1}
      pt={1}
    >
      <OrderDetails />
    </PageLayout>
  </AuthGuard>
)

export default Selected
